<template>
  <div class="container" v-if="item">
    <h1>
      {{ item.name || 'Image' }}
      <span class="pull-right">
        <router-link class="btn btn-primary btn-sm" :to="`/images/${item._id}/edit`" v-if="canEdit">
          Edit
        </router-link>
      </span>
    </h1>
    <hr>

    <div class="row">
      <div class="col text-center">
        <img v-if="item && item.url" :src="item.url">
      </div>
      <div class="col" v-if="item && item.description">
        <h3>Description</h3>
        <div v-html="$embers.markdown(item.description)"></div>
      </div>
    </div>

    <rulebook-footer :item="item"></rulebook-footer>

    <div class="row hidden-print return-to-list">
      <div class="col text-center">
        <router-link :to="`/images#${$embers.slugify(item.name)}`"><i class="fa fa-angle-double-left"></i> Return to list</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import RulebookFooter from "@/components/shared/_RulebookFooter";

export default {
  name: "image-show",
  components: {
    RulebookFooter
  },
  watch: {
    // call again the method if the route changes
    $route: "getData"
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters({ canEdit: "images/canEdit" }),
    ...mapState({
      item: state => state.images.current
    })
  },
  methods: {
    ...mapActions({
      imagesRead: "images/read"
    }),
    lowerCase(value) {
      return value.toLowerCase();
    },
    async getData() {
      try {
        await this.imagesRead({ id: this.$route.params.id });
        this.$embers.pageData(this.item.name, this.item.summary);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
